/**
 * @generated SignedSource<<4bf86deb3666da4f8cb6144c5a396fec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ServiceOptionEditForm_serviceOption$data = {
  readonly id: string;
  readonly name: string;
  readonly price: number | null;
  readonly scoroProductId: number | null;
  readonly " $fragmentType": "ServiceOptionEditForm_serviceOption";
};
export type ServiceOptionEditForm_serviceOption$key = {
  readonly " $data"?: ServiceOptionEditForm_serviceOption$data;
  readonly " $fragmentSpreads": FragmentRefs<"ServiceOptionEditForm_serviceOption">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ServiceOptionEditForm_serviceOption",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scoroProductId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "price",
      "storageKey": null
    }
  ],
  "type": "ServiceOption",
  "abstractKey": null
};

(node as any).hash = "0e220acc6642d7aaaf46294f5936a0e0";

export default node;
